/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm, replacePXinStringWithEM, displayTypes, centerAbsolutely } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED : CONTENT : QUIZ : STYLES --------------- ++++++++++ */
export default {
	quiz: {

	}
};
